const COUNT_PLACEHOLDER = '12345';

class CollectionVariantCardCount {
  static init() {
    document.querySelectorAll('[data-variant-card-count]').forEach((element) => {
      CollectionVariantCardCount.updateElement(element);
    });
  }

  static getFilterParams() {
    const params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('section_id');
    return params.toString();
  }

  static resolveCollectionUrl(collectionUrl) {
    if (!collectionUrl) {
      return null;
    }

    if (collectionUrl.startsWith('/')) {
      return `${window.location.origin}${collectionUrl}`;
    }

    try {
      const parsed = new URL(collectionUrl, window.location.origin);
      return `${window.location.origin}${parsed.pathname}`;
    } catch (error) {
      return collectionUrl;
    }
  }

  static async fetchAllProducts(collectionUrl, filterQueryString) {
    const products = [];
    const resolvedCollectionUrl = CollectionVariantCardCount.resolveCollectionUrl(collectionUrl);

    if (!resolvedCollectionUrl) {
      return products;
    }

    let page = 1;

    for (;;) {
      const queryParts = [`limit=250`, `page=${page}`];

      if (filterQueryString) {
        const filterParams = new URLSearchParams(filterQueryString);
        filterParams.forEach((value, key) => {
          queryParts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
        });
      }

      const response = await fetch(`${resolvedCollectionUrl}/products.json?${queryParts.join('&')}`, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        break;
      }

      const data = await response.json();

      if (!data.products?.length) {
        break;
      }

      products.push(...data.products);

      if (data.products.length < 250) {
        break;
      }

      page += 1;
    }

    return products;
  }

  static countCards(products) {
    let count = 0;

    for (const product of products) {
      const variants = product.variants || [];

      if (variants.length > 1) {
        const available = variants.filter((variant) => variant.available);
        count += available.length > 0 ? available.length : 1;
      } else {
        count += 1;
      }
    }

    return count;
  }

  static formatSimpleCount(template, count) {
    if (!template) {
      return String(count);
    }

    return template.replaceAll(COUNT_PLACEHOLDER, String(count));
  }

  static formatFilteredCount(template, productCount, totalCount) {
    if (!template) {
      return String(productCount);
    }

    return template.replace('__PRODUCT_COUNT__', String(productCount)).replace('__TOTAL_COUNT__', String(totalCount));
  }

  static async updateElement(element) {
    const expandVariants = element.dataset.expandVariants === 'true';

    if (!expandVariants || !element.dataset.collectionUrl) {
      element.classList.remove('loading');
      return;
    }

    element.classList.add('loading');

    const collectionUrl = element.dataset.collectionUrl;
    const productsCount = Number.parseInt(element.dataset.productsCount, 10);
    const allProductsCount = Number.parseInt(element.dataset.allProductsCount, 10);
    const filterParams = CollectionVariantCardCount.getFilterParams();

    try {
      const filteredProducts = await CollectionVariantCardCount.fetchAllProducts(collectionUrl, filterParams);
      const filteredCardCount = CollectionVariantCardCount.countCards(filteredProducts);

      if (productsCount !== allProductsCount && element.dataset.countFiltered) {
        const allProducts = await CollectionVariantCardCount.fetchAllProducts(collectionUrl, '');
        const totalCardCount = CollectionVariantCardCount.countCards(allProducts);
        element.innerHTML = CollectionVariantCardCount.formatFilteredCount(
          element.dataset.countFiltered,
          filteredCardCount,
          totalCardCount
        );
      } else {
        element.innerHTML = CollectionVariantCardCount.formatSimpleCount(
          element.dataset.countSimple,
          filteredCardCount
        );
      }
    } catch (error) {
      console.error(error);
    } finally {
      element.classList.remove('loading');
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  CollectionVariantCardCount.init();
});

window.CollectionVariantCardCount = CollectionVariantCardCount;
